import script from "./sidebarView.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebarView.vue?vue&type=script&setup=true&lang=js"

import "./sidebarView.vue?vue&type=style&index=0&id=19309d36&scoped=true&lang=css"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19309d36"]])

export default __exports__